<template>
  <div class="parentstylemobile">
    <div class="mainstylemobile"
      v-for="p in paginatedData"
      :key="p.id"
      deck
    >
      <router-link class="routerlink" :to="`/estimate/${p.id}`">
        <div class="card" style="min-width: 310px; max-width: 310px; height: 280px">
           <img class="card-img-top" :src="p.srcImg">
           <div class="card-body">
             <h4 class="card-title card-titles"><a>{{p.brandDescription + ' ' + p.name}}</a></h4>
             <p class="card-text"><span class="cardtext">월 {{p.monthlyPrice}}만원</span></p>
             <p class="card-text"><span class="cardtext">금리 {{p.interestRate}}%</span></p>
             <button class="btn btn-sm btn-warning">
               견적서 확인
                 <i class="fas fa-chevron-circle-right pl-1"></i>
            </button>
           </div>
        </div>
      </router-link>
    </div>
    <div class="fluid btn-cover">
      <button
        :disabled="pageNum === 0"
        @click="prevPage"
        class="page-btn"
      >
        이전
      </button>
      <span class="page-count">
        {{ pageNum + 1 }} / {{ pageCount }} 페이지
      </span>
      <button
        :disabled="pageNum >= pageCount - 1"
        @click="nextPage"
        class="page-btn"
      >
        다음
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageNum: 0,
    };
  },
  props: {
    listArray: {
      type: Array,
      required: true,
    },
    pageSize: {
      type: Number,
      required: false,
      default: 4, // 한페이지에 표시 할 이미지 개수
    },
  },
  methods: {
    nextPage() {
      this.pageNum += 1;
      document.getElementById('maincarlist').scrollIntoView();
    },
    prevPage() {
      this.pageNum -= 1;
      document.getElementById('maincarlist').scrollIntoView();
    },
    sortData() {
      return this.listArray.sort((a, b) => a.carsOrderBy - b.carsOrderBy);
    },
  },
  computed: {
    pageCount() {
      const listLeng = this.listArray.length;
      const listSize = this.pageSize;
      let page = Math.floor(listLeng / listSize);
      if (listLeng % listSize > 0) page += 1;
      return page;
    },
    paginatedData() {
      const start = this.pageNum * this.pageSize;
      const end = start + this.pageSize;
      return this.sortData().slice(start, end);
    },
  },
};
</script>

<style scoped>
.parentstylemobile{
  text-align:center;
}
/* unvisited link */
.routerlink:link {
  color: black;
}
/* visited link */
.routerlink:visited {
  color: black;
}
/* mouse over link */
.routerlink:hover {
  color: #ffba00;
}
/* selected link */
.routerlink:active {
  color: #ffba00;
}
.mainstylemobile{
  border: 1px solid #ffffff;
  line-height: 0;
  text-align: center;
  margin-top: 1px;
  margin-bottom: 20px;
  display:inline-block;
  align-content: center;
  margin-left: 0px;
  margin-right: 20px;
}
.cardss {
  float:left;
}
.card:hover {
    border: 1px solid black;
}
.card-titles {
  font-size: 19px;
  font-family: "Proxima Nova";
}
.card-img-top {
  padding-top : 0px;
  width: 250px;
  height: 125px;
  object-fit: fill;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
}
.cardtext {
  font-size: 17px;
  color: #ffba00;
}
.btn-cover {
  clear: left;
  align-content: center;
  margin-top: 24px;
  margin-bottom: 9px;
  text-align: center;
}
.btn-cover .page-btn {
  width: 80px;
  height: 32px;
  letter-spacing: 0.5px;
  background-color: black;
  color: white;
}
.btn-cover .page-count {
  padding: 0 16px;
}
.sbutton{
  background-color: #ffba00 !important;
  width: 140px;
  height: 30px;
  color: black;
  text-align: center;
  padding: 0px;
  font-size: 15px;
}
.btn-secondary:hover {
    color: #fff;
    background-color: #ffba00;
}
.btn {
  color: black;
  background-color: #ffba00;
}
.btn-warning {
  background-color: #ffba00 !important;
}
.btn.btn-sm {
  font-size: 13px;
}
.btn-outline-warning {
    color: black !important;
    background-color: transparent !important;
    border: 2px solid #fb3 !important;
}
</style>
